import React, { useEffect } from "react";
import Header from "../../lib/Common/Header";
import styles from "../../lib/Common/commonStyles";
import OfferCard from "../../lib/Common/OfferCard";
import Footer from "../../lib/Common/Footer";
import { useTranslation } from "react-i18next";

// Summary section
const Summary = ({ data, setStep, t }) => (
  <div className="text-white mb-md-2 d-flex flex-column align-items-center ">
    <div className="w-100 maxWidth800 summary-responsive">
      <h2 className="fontSize32Regular mb-md-4 mb-2 lineHeight38 textGreen">
        {t("Summary")}
      </h2>
      <div className="row g-3 mb-2 mb-md-4">
        {/* Location */}
        <div className="col-12 col-sm-6 col-lg-3 d-flex align-items-center">
          <img
            src={require("../../assets/images/location-wbg.png")}
            height={50}
            width={50}
            alt="Location"
            className="me-3 me-md-4 flex-shrink-0"
          />
          <div className="d-flex flex-column">
            <span className="textGreen fontSize14Regular lineHeight18">
              {t("Location")}:
            </span>
            <span className="text-white fontSize14Medium lineHeight18">
              {data?.postalCode}
            </span>
          </div>
        </div>

        {/* Smart Meter */}
        <div className="col-12 col-sm-6 col-lg-3 d-flex align-items-center">
          <img
            src={require("../../assets/images/smart-vector-wbg.png")}
            height={50}
            width={50}
            alt="Smart Meter"
            className="me-3 me-md-4 flex-shrink-0"
          />
          <div className="d-flex flex-column">
            <span className="textGreen fontSize14Regular lineHeight18">
              {t("Smart meter")}:
            </span>
            <span className="text-white fontSize14Medium lineHeight18">
              {data?.hasSmartMeter ? <>{t("Yes")}</> : <>{t("no")}</>}
            </span>
          </div>
        </div>

        {/* Customer Type */}
        <div className="col-12 col-sm-6 col-lg-3 d-flex align-items-center">
          <img
            src={require("../../assets/images/home-wbg.png")}
            height={50}
            width={50}
            alt="Customer Type"
            className="me-3 me-md-4 flex-shrink-0"
          />
          <div className="d-flex flex-column">
            <span className="textGreen fontSize14Regular lineHeight18">
              {t("Customer Type:")}
            </span>
            <span className="text-white text-capitalize fontSize14Medium lineHeight18">
              {data?.customerType == "private" ? (
                <>{t("Private")}</>
              ) : (
                <>{t("Business")}</>
              )}
            </span>
          </div>
        </div>

        {/* Consumption */}
        <div className="col-12 col-sm-6 col-lg-3 d-flex align-items-center">
          <img
            src={require("../../assets/images/consumption-wbg.png")}
            height={50}
            width={50}
            alt="Consumption"
            className="me-3 me-md-4 flex-shrink-0"
          />
          <div className="d-flex flex-column">
            <span className="textGreen fontSize14Regular lineHeight18">
              {t("Consumption")}:
            </span>
            <span className="text-white fontSize14Medium lineHeight18">
              {data?.energyConsumption} kWh
            </span>
          </div>
        </div>
      </div>

      <button
        className="text-white fontSize16Medium px-5 py-2 lineHeight24 borderRadius12 border-1 border-green change-button  mt-3 button_green"
        style={{ ...styles.border1pxSolidgreen }}
        onClick={() => {
          setStep(0);
        }}
      >
        {t("Change")}
      </button>
      <p className="fontSize32Regular lineHeight38 mt-3 mt-md-5 textGreen">
        {t("Your Offers")}
      </p>
    </div>
  </div>
);

// Main component
const EnergyOffers = ({ setStep, values, formData, setFormData }) => {
  const { t } = useTranslation();
  useEffect(() => {
    setFormData({
      ...formData,
      personalInformation: {
        ...formData?.personalInformation,
        email: values?.email || formData?.personalInformation?.email || "",
      },
      deliveryAddress: {
        ...formData?.deliveryAddress,
        deliv_address_zipcode: values?.postalCode || "",
      },
    });
  }, []);

  return (
    <>
      {/* min-vh-100 */}
      <Header contract={true} />
      <div className=" responsive-padding px-3 backgroundColorCommon">
        <div className="container-xxl">
          <Summary data={values} setStep={setStep} t={t} />

          <div className="d-flex flex-column align-items-center">
            {values?.data?.map((offer, index) => (
              <OfferCard
                key={index}
                values={offer}
                setStep={setStep}
                visible={true}
                data={values}
              />
            ))}
            {/* <OfferCard values={values} setStep={setStep} visible={true} /> */}
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default EnergyOffers;
